import {useEffect, useState} from "react";
import {useProfile} from "@brg/auth";
import {API, Endpoints} from "@brg/api";

export const useGetCollectionCards = (collectionId: string, collectionType: number | undefined, context: string, page: number, t?: number) => {
    const [resp, setResp] = useState<any>(undefined);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(false);
    const profile = useProfile();

    useEffect(() => {
        if (collectionId && collectionType !== undefined && context !== undefined) {
            setIsLoading(true);
            API.request()
                .endpoint(Endpoints.geograffee)
                .url('/api/pools/GetRatings')
                .addQuery('entityId', collectionId)
                .addQuery('entityType', 'collection')
                .addQuery('entityExtraType', collectionType)
                .addQuery('context', context)
                .addQuery('page', page)
                .addQuery('limit', 20)
                .get()
                .send()
                .then((r) => r.json())
                .then((r) => {
                    setResp(r);
                    setIsLoading(false)
                })
                .catch((err) => setError(err));
        }
    }, [profile?.accountId, collectionType, collectionId, t, page, context])

    return {resp: resp, isLoading, error};
}import {useEffect, useState} from "react";
import {useProfile} from "@brg/auth";
import {API, Endpoints} from "@brg/api";

export const useGetCollectionCards = (collectionId: string, collectionType: number | undefined, context: string, page: number, t?: number) => {
    const [resp, setResp] = useState<any>(undefined);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(false);
    const profile = useProfile();

    useEffect(() => {
        if (collectionId && collectionType !== undefined && context !== undefined) {
            setIsLoading(true);
            API.request()
                .endpoint(Endpoints.geograffee)
                .url('/api/pools/GetRatings')
                .addQuery('entityId', collectionId)
                .addQuery('entityType', 'collection')
                .addQuery('entityExtraType', collectionType)
                .addQuery('context', context)
                .addQuery('page', page)
                .addQuery('limit', 20)
                .get()
                .send()
                .then((r) => r.json())
                .then((r) => {
                    setResp(r);
                    setIsLoading(false)
                })
                .catch((err) => setError(err));
        }
    }, [profile?.accountId, collectionType, collectionId, t, page, context])

    return {resp: resp, isLoading, error};
}